module.exports = __webpack_public_path__ + "static/media/figma.ebe880ba.png";